var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3592_248440)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 21,
    stroke: "#FCF7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3592_248440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7584 28.7895C35.7116 28.767 33.962 27.9054 33.651 27.7935C33.5241 27.748 33.3881 27.7035 33.2435 27.7035C33.0073 27.7035 32.8088 27.8212 32.6542 28.0525C32.4794 28.3123 31.9503 28.9307 31.7868 29.1155C31.7655 29.1399 31.7363 29.169 31.7189 29.169C31.7032 29.169 31.4324 29.0575 31.3505 29.0219C29.4736 28.2066 28.0489 26.246 27.8536 25.9154C27.8257 25.8679 27.8245 25.8463 27.8243 25.8463C27.8311 25.8211 27.8942 25.7578 27.9268 25.7252C28.0221 25.6309 28.1254 25.5066 28.2253 25.3864C28.2726 25.3294 28.3199 25.2724 28.3664 25.2186C28.5114 25.05 28.5759 24.9191 28.6507 24.7674L28.6899 24.6887C28.8726 24.3258 28.7166 24.0195 28.6661 23.9207C28.6248 23.8379 27.886 22.0549 27.8074 21.8676C27.6186 21.4155 27.369 21.2051 27.0221 21.2051C26.99 21.2051 27.0221 21.2051 26.8872 21.2108C26.7228 21.2177 25.8279 21.3355 25.4322 21.5849C25.0126 21.8495 24.3027 22.6928 24.3027 24.1758C24.3027 25.5105 25.1497 26.7707 25.5134 27.25C25.5224 27.2621 25.539 27.2867 25.5631 27.3219C26.9558 29.3558 28.692 30.8631 30.452 31.5662C32.1464 32.2431 32.9488 32.3213 33.405 32.3213C33.405 32.3213 33.405 32.3213 33.405 32.3213C33.5967 32.3213 33.7502 32.3062 33.8855 32.2929L33.9714 32.2847C34.5567 32.2328 35.8431 31.5663 36.1357 30.7532C36.3662 30.1127 36.4269 29.413 36.2736 29.1591C36.1686 28.9864 35.9875 28.8995 35.7584 28.7895Z",
    fill: "#606062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.213 15C23.7131 15 18.425 20.2484 18.425 26.6995C18.425 28.786 18.9834 30.8284 20.0412 32.6159L18.0165 38.5883C17.9788 38.6996 18.0068 38.8227 18.0892 38.9066C18.1487 38.9673 18.2293 39 18.3117 39C18.3432 39 18.375 38.9952 18.406 38.9854L24.6336 37.0064C26.3377 37.917 28.2638 38.3976 30.2131 38.3976C36.7124 38.3977 42 33.1498 42 26.6995C42 20.2484 36.7124 15 30.213 15ZM30.213 35.9606C28.3788 35.9606 26.6023 35.4309 25.0752 34.4289C25.0238 34.3951 24.9642 34.3778 24.9042 34.3778C24.8725 34.3778 24.8407 34.3826 24.8097 34.3925L21.6901 35.3841L22.6972 32.413C22.7298 32.3169 22.7135 32.2108 22.6535 32.1288C21.4906 30.5398 20.8759 28.6625 20.8759 26.6995C20.8759 21.5922 25.0645 17.4371 30.2129 17.4371C35.3608 17.4371 39.5489 21.5922 39.5489 26.6995C39.549 31.8061 35.3609 35.9606 30.213 35.9606Z",
    fill: "#606062"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3592_248440",
    x: 0,
    y: 0,
    width: 63,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.313726 0 0 0 0 0.313726 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3592_248440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3592_248440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3592_248440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.6953d61b4c9627e2752b6dfe75531b7b.svg";
export { ForwardRef as ReactComponent };